import React, { useState } from 'react';
import styles from './ResumeDisplay.module.css';

const SECTION_LABELS = {
  education: 'Education',
  experience: 'Experience',
  exhibitions: 'Exhibitions',
  awards: 'Awards',
  publications: 'Publications',
  collections: 'Collections'
};

const ResumeDisplay = ({ data, rawText }) => {
  const [viewMode, setViewMode] = useState(rawText ? 'document' : 'sections');

  if (!data && !rawText) return null;

  let resumeData;
  try {
    resumeData = typeof data === 'string' ? JSON.parse(data) : data;
  } catch (e) {
    console.error('Error parsing resume data:', e);
    return <div className={styles.error}>Unable to display resume data</div>;
  }

  const hasContent = resumeData && Object.values(resumeData).some(section => 
    Array.isArray(section) && section.length > 0
  );

  const renderField = (key, value) => {
    if (!value) return null;
    return (
      <div key={key} className={styles.field}>
        <strong>{key}:</strong> {value}
      </div>
    );
  };

  const renderItem = (item, sectionKey) => {
    if (typeof item === 'string') {
      return <p key={item} className={styles.description}>{item}</p>;
    }

    return (
      <div className={styles.item}>
        {Object.entries(item).map(([key, value]) => {
          if (key === 'description') {
            return <p key={key} className={styles.description}>{value}</p>;
          }
          return renderField(key, value);
        })}
      </div>
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.controls}>
        <button
          className={`${styles.viewButton} ${viewMode === 'document' ? styles.active : ''}`}
          onClick={() => setViewMode('document')}
        >
          Document View
        </button>
        <button
          className={`${styles.viewButton} ${viewMode === 'sections' ? styles.active : ''}`}
          onClick={() => setViewMode('sections')}
        >
          Section View
        </button>
      </div>
      {viewMode === 'document' ? (
        rawText ? (
          <div className={styles.documentView}>
            <pre className={styles.rawText}>{rawText}</pre>
          </div>
        ) : (
          <div className={styles.empty}>No uploaded resume document.</div>
        )
      ) : (
        hasContent ? (
          Object.entries(resumeData).map(([section, items]) => {
        if (!Array.isArray(items) || items.length === 0) return null;
        return (
          <div key={section} className={styles.section}>
            <h3>{SECTION_LABELS[section]}</h3>
            <div className={styles.items}>
              {items.map((item, index) => (
                <div key={index} className={styles.itemWrapper}>
                  {renderItem(item, section)}
                </div>
              ))}
            </div>
          </div>
        );
          })
        ) : (
          <div className={styles.empty}>No resume information available</div>
        )
      )}
    </div>
  );
};

export default ResumeDisplay; 